import React, {FC, useEffect, useState} from 'react';
import GatewayService from "../../service/GatewayService";
import {ComboOrder, TodayTrades} from "../../models/TodayTrades";
import AppConstants from "../../util/AppConstants";
import {DropDownCompString, getKeyVal} from "../util/DropDownComp";
import {toast} from "react-hot-toast";
import AppUtil from "../../util/AppUtil";

const TodayTradesComponent: FC = () => {
    const [client, setClient] = useState<string>("RHN1310_U");
    // const [client, setClient] = useState<string>(AppConstants.CLIENTS[0]);
    const [todayTrades, setTodayTrades] = useState<TodayTrades | null>(null);
    const [selectedTradeIds, setSelectedTradeIds] = useState<string[]>([]);

    const fetchTrades = () => {
        if (client) {
            GatewayService.getTodayTrades(client).then(data => {
                setTodayTrades(data);
                setSelectedTradeIds([]);
            }).catch(err => {
                console.error(err);
                toast.error("Failed to fetch trades.");
            });
        }
    };

    useEffect(() => {
        setTodayTrades(null);
        setSelectedTradeIds([]);
        fetchTrades();
    }, [client]);

    const handleCreateCombo = () => {
        if (selectedTradeIds.length === 0) {
            toast.error("Please select trades to create a combo.");
            return;
        }
        GatewayService.createCombo(client, selectedTradeIds).then(newCombo => {
            toast.success(`Combo ${newCombo.name} created.`);
            // Refresh data
            GatewayService.getTodayTrades(client).then(setTodayTrades);
            setSelectedTradeIds([]);
        }).catch(err => {
            console.error(err);
            toast.error("Failed to create combo.");
        });
    };

    const handleTradeSelection = (tradeId: string) => {
        setSelectedTradeIds(prev =>
            prev.includes(tradeId)
                ? prev.filter(id => id !== tradeId)
                : [...prev, tradeId]
        );
    };

    const allComboOrderIds = todayTrades?.combos.flatMap(c => c.orders.map(o => o.orderId)) || [];
    const uncomboedTrades = todayTrades?.trades.filter(t => !allComboOrderIds.includes(t.orderId)) || [];

    return (
        <div>
            <div>

                Total buys : {
                AppUtil.getLacks(todayTrades?.trades
                    .filter(it => it.transaction_type.toUpperCase()=="BUY")
                    .map(it => it.quantity*it.average_price*it.multiplier)
                    .reduce((a, b) => a + b, 0)
                )
            }
            </div>
            <div>
                Total sells : {
                AppUtil.getLacks(
                    todayTrades?.trades
                        .filter(it => it.transaction_type.toUpperCase()=="SELL")
                        .map(it => it.quantity*it.average_price*it.multiplier)
                        .reduce((a, b) => a + b, 0)
                )
            }
            </div>
            <h2>Today's Trades</h2>
            <DropDownCompString
                text={"Client"}
                actual={client}
                arr={getKeyVal(AppConstants.CLIENTS)}
                set={setClient}
            />
            <button onClick={fetchTrades}>Refresh</button>

            <h3>Un-comboed Trades</h3>
            {uncomboedTrades.length > 0 && (
                <button onClick={handleCreateCombo} disabled={selectedTradeIds.length === 0}>
                    Create Combo from Selected
                </button>
            )}
            <table>
                <thead>
                <tr>
                    <th>Select</th>
                    <th>Symbol</th>
                    <th>Type</th>
                    <th>Qty</th>
                    <th>Price</th>
                    <th>Time</th>
                    <th>OrderId</th>
                </tr>
                </thead>
                <tbody>
                {uncomboedTrades.map(trade => (
                    <tr key={trade.trade_id}>
                        <td>
                            <input
                                type="checkbox"
                                checked={selectedTradeIds.includes(trade.orderId)}
                                onChange={() => handleTradeSelection(trade.orderId)}
                            />
                        </td>
                        <td>{trade.tradingsymbol}</td>
                        <td>{trade.transaction_type}</td>
                        <td>{trade.quantity}</td>
                        <td>{trade.average_price}</td>
                        <td>{trade.order_timestamp}</td>
                        <td>{trade.orderId}</td>
                    </tr>
                ))}
                </tbody>
            </table>

            <h3>Combo Orders</h3>
            {todayTrades?.combos.map((combo, index) => (
                <div key={index} style={{ border: '1px solid #ccc', margin: '10px', padding: '10px' }}>
                    <h4>{combo.name} ({combo.type}) - {new Date(combo.time).toLocaleString()}</h4>
                    <p>Client: {combo.clientId}, Premium Received: {combo.premiumReceived}, Tax: {combo.tax}</p>
                    <table>
                        <thead>
                        <tr>
                            <th>Symbol</th>
                            <th>Side</th>
                            <th>Qty</th>
                            <th>Price</th>
                            <th>Time</th>
                            <th>OrderId</th>
                        </tr>
                        </thead>
                        <tbody>
                        {combo.orders.map(order => (
                            <tr key={order.orderId}>
                                <td>{order.tradingSymbol}</td>
                                <td>{order.isBuy ? 'BUY' : 'SELL'}</td>
                                <td>{order.qty}</td>
                                <td>{order.price}</td>
                                <td>{new Date(order.timestamp).toLocaleString()}</td>
                                <td>{order.orderId}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            ))}
        </div>
    );
};

export default TodayTradesComponent;
